import './App.css';
import React, {useEffect, useRef, useState} from "react";
import styled from 'styled-components';
import { connect } from 'react-redux';
import * as selectors from '../../../selectors';
import * as actions from '../../../actions';
import saga from '../../../saga';
import { createStructuredSelector } from 'reselect';
import { useInjectSaga } from '../../../utils/injectSaga';
import {PAGES} from "../../../common/constants";
import CalendarPage from "../CalendarPage";
import EnterDetailsPage from "../EnterDetailsPage";
import MeetingConfirmedPage from "../MeetingConfirmedPage";
import BackgroundImage from "../../components/BackgroundImage";
import LoadingPage from "../LoadingPage";
import ErrorPage from "../ErrorPage";
import UserNotFound from "../UserNotFound";
import AuthPage from "../AuthPage";
import AuthResponse from "../AuthResponse";
import {DEVICE_WIDTH} from "../../../common/constants";
import {ReactComponent as CloseIcon} from "../../../assets/icons/close-icon-small.svg";
import DotLoader from "../../components/DotLoader";
import OnboardingPage from "../OnboardingPage";
import IntegrationErrorPage from "../IntegrationErrorPage";
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import ReCaptcha from "../../components/ReCaptcha";
import {setCaptchaToken} from "../../../actions";
import ReCAPTCHA from "react-google-recaptcha";
import {CAPTCHA_SITE_KEY} from "../../../config";
import GetInputsPage from "../GetInputsPage";
import {ReactComponent as ZiIcon} from "../../../assets/icons/zi-logo-small.svg";

function CircularIndeterminate() {
    return (
        <Stack sx={{ color: '#FFFFFF' }} spacing={2} direction="row">
            <CircularProgress color="inherit" size="50px" />
        </Stack>
    );
}
const AppContainer = styled.div`
  display: flex;
  justify-content: ${p => (p.isIframe && p.currentPage !== PAGES.LOADING_PAGE) ? "center" : "center"};
  align-items: center;
  text-align: center;
  min-height: 100vh;
  z-index: -2;
  background-color: transparent;
  ${p => p.isOnboardingPage ? "background-color: #ECECEC" : ""};
  ${p => p.isIframe ? 'flex-direction : column':''};
  @media (max-width: ${DEVICE_WIDTH.MOBILE}px) {
    ${p => p.isErrorPage ? '' : 'align-items: start'};
  }
`;

const Card = styled.div`
  ${p => (p.isIframe && p.currentPage!==PAGES.LOADING_PAGE) ? 'position: relative':''};
  ${p => (p.isIframe && p.currentPage!==PAGES.LOADING_PAGE) ? 'background-color: #FFFFFF':''};
  ${p => (p.isIframe && p.currentPage!==PAGES.LOADING_PAGE) ? 'border: 1px solid #E8EBED':''};
  ${p => (p.isIframe && p.currentPage!==PAGES.LOADING_PAGE) ? 'box-sizing: border-box':''};
  ${p => (p.isIframe && p.currentPage!==PAGES.LOADING_PAGE) ? 'border-radius: 20px;':''};
  ${p => (p.isIframe && p.currentPage!==PAGES.LOADING_PAGE) ? 'padding: 40px 32px 8px':''};
  ${p => p.isIframe ? 'box-shadow: 0 0 0 100vmax rgba(0, 0, 0, .5)' : ''};
  ${p => (p.isIframe && p.currentPage!==PAGES.LOADING_PAGE) ? 'width: fit-content' : ''};
`;

const CardContainer = styled.div`
  ${p => p.isIframe ? 'display: flex':''};
  ${p => p.isIframe ? 'flex-direction:column':''};
  ${p => p.isIframe ? 'align-items: flex-end':''};
  ${p => p.isIframe ? 'padding:24px':''};
`;

const PoweredByZI = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 11px;
  line-height: 20px;
  color: #546B8F;
  margin-top: 32px;
  p {
    margin: 0 0 0 8px;
  }
`;

const CloseIconContainer = styled.div`
  position: absolute;
  top: 18px;
  right: 18px;
  cursor: pointer;
`

const App = props => {
    const {history} = props;
    useInjectSaga({ key: 'global', saga });
    const isCaptchaToken = useRef(false);
    const recaptchaRef = useRef();
    const [initialStateFetched, setInitialStateFetched] = useState(false);
    const {
        currentPage,
        isIframe,
        getInitialState,
        captchaToken,
        setCaptchaToken
    } = props;

    const getCaptchaToken = async () => {
        if(!recaptchaRef?.current) return;
        const captchaToken = await recaptchaRef.current.executeAsync();
        recaptchaRef.current.reset();
        if(captchaToken) setCaptchaToken(captchaToken);
        return captchaToken;
    }

    useEffect(() => {
        getCaptchaToken();
    }, [])

    useEffect(() => {
        const search = window.location.search;
        const path = window.location.pathname;
        let splitPath = path.split('/').filter((e, index) => {
            if(index===0 || index===path.split('/').length-1) {
                return e!=="";
            }
            else return true;
        });
        const user = path.split('/')[1].toString();
        if(captchaToken || user?.toLowerCase()==="onboard" || user?.toLowerCase()==="connect") isCaptchaToken.current = true;
        if(isCaptchaToken.current && !initialStateFetched) {
            getInitialState(captchaToken);
            setInitialStateFetched(true);
        }
    }, [captchaToken])



  return (
    <AppContainer isErrorPage={currentPage === PAGES.ERROR_PAGE} currentPage={currentPage} isOnboardingPage={currentPage === PAGES.ONBOARDING_PAGE} isMeetingConfirmedPage={currentPage === PAGES.MEETING_CONFIRMED_PAGE} isIframe={isIframe}>
        {(currentPage===PAGES.CALENDAR_PAGE || currentPage===PAGES.ENTER_DETAILS_PAGE || currentPage === PAGES.LOADING_PAGE || currentPage === PAGES.GET_INPUTS_PAGE || !currentPage) && <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={CAPTCHA_SITE_KEY}
            size="invisible"
        />}
        {currentPage === PAGES.LOADING_PAGE && (isCaptchaToken.current || captchaToken) && isIframe && <CircularIndeterminate />}
        {(isCaptchaToken.current || captchaToken) && <CardContainer isIframe={isIframe} currentPage={currentPage}>
            <Card isIframe={isIframe} currentPage={currentPage}>
            {isIframe && currentPage!==PAGES.LOADING_PAGE && <CloseIconContainer onClick={() => {window.top.postMessage("SCHEDULE_CLOSE", "*")}}><CloseIcon display="block" /></CloseIconContainer>}
            {currentPage === PAGES.CALENDAR_PAGE && <CalendarPage getCaptchaToken={getCaptchaToken} />}
            {currentPage === PAGES.ENTER_DETAILS_PAGE && <EnterDetailsPage history={history} getCaptchaToken={getCaptchaToken} />}
            {currentPage === PAGES.MEETING_CONFIRMED_PAGE && <MeetingConfirmedPage isIframe={isIframe}/>}
            {(currentPage === PAGES.LOADING_PAGE && !isIframe) && <LoadingPage/>}
            {currentPage === PAGES.ERROR_PAGE && <ErrorPage/>}
            {currentPage === PAGES.GET_INPUTS_PAGE && <GetInputsPage getCaptchaToken={getCaptchaToken} />}
            {currentPage === PAGES.USER_NOT_FOUND && <UserNotFound/>}
            {currentPage === PAGES.AUTH_PAGE && <AuthPage/>}
            {currentPage === PAGES.AUTH_RESPONSE && <AuthResponse/>}
            {currentPage === PAGES.ONBOARDING_PAGE && <OnboardingPage />}
            {currentPage === PAGES.INTEGRATION_ERROR_PAGE && <IntegrationErrorPage />}
            {isIframe && currentPage !== PAGES.LOADING_PAGE ? (
                <PoweredByZI>
                    <ZiIcon />
                        <p>Powered by ZoomInfo</p>
                </PoweredByZI>
            ) : null}
            </Card>
        </CardContainer>}
        {!isIframe && <BackgroundImage isMeetingConfirmedPage={currentPage === PAGES.MEETING_CONFIRMED_PAGE}/>}
    </AppContainer>
  );
}

export const mapStateToProps = (state, props) => {
    return createStructuredSelector({
        currentPage: selectors.makeSelectCurrentPage(),
        isIframe: selectors.makeSelectIsIframe(),
        meeting: selectors.makeSelectMeeting(),
        user: selectors.makeSelectUser(),
        routerId: selectors.makeSelectRouterId(),
        captchaToken: selectors.makeSelectCaptchaToken(),
    });
};

export const mapDispatchToProps = dispatch => {
    return {
        getInitialState: captchaToken => dispatch(actions.getInitialState.start(captchaToken)),
        setCaptchaToken: token => dispatch(actions.setCaptchaToken(token)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
